import './footer.css';
import { faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";
import { faInstagram} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Footer() {
    return (
        <div className="footer">
            <h2 id="contact" className="footer-title">Kontakt</h2>
            <ul className="contact-list">
                <li>
                    <span><FontAwesomeIcon icon={faPhone} /></span>
                    Tel:  <a href="tel:065 873 60 21">065 873 60 21</a>
                </li>
                <li>
                    <span><FontAwesomeIcon icon={faEnvelope} /></span>
                    Email:  <a href = "mailto:selenarboskovic@gmail.com?subject=ČASOVI HEMIJE">selenarboskovic@gmail.com</a>
                </li>
                <li>
                    <span><FontAwesomeIcon icon={faInstagram} /></span>
                    Instagram:  <a href="https://www.instagram.com/prijemni_ispiti_hemija" target="_blank">prijemni_ispiti_hemija</a>
                </li>
            </ul>
        </div>
    );
}

